class GiftCardForm extends HTMLElement {
	constructor() {
		super();
		this.config = {
			selectedAmount: null,
			isCustomAmount: false,
		};

		this.handleAmountSelection = this.handleAmountSelection.bind(this);
		this.handleCustomAmountInput = this.handleCustomAmountInput.bind(this);
		this.handleFormSubmit = this.handleFormSubmit.bind(this);

		this.cartDrawer = document.querySelector("cart-drawer");
		this.mainCart = document.querySelector("cart-items");
	}

	connectedCallback() {
		this.attachEventListeners();
	}

	disconnectedCallback() {
		this.removeEventListeners();
	}

	attachEventListeners() {
		this.querySelectorAll(".amount-btn").forEach((btn) => {
			btn.addEventListener("click", this.handleAmountSelection);
		});

		const customAmountInput = this.querySelector("#customAmount");
		if (customAmountInput) {
			customAmountInput.addEventListener("input", this.handleCustomAmountInput);
		}

		const form = this.querySelector("#giftCardForm");
		if (form) {
			form.addEventListener("submit", this.handleFormSubmit);
		}
	}

	removeEventListeners() {
		this.querySelectorAll(".amount-btn").forEach((btn) => {
			btn.removeEventListener("click", this.handleAmountSelection);
		});

		const customAmountInput = this.querySelector("#customAmount");
		if (customAmountInput) {
			customAmountInput.removeEventListener(
				"input",
				this.handleCustomAmountInput,
			);
		}

		const form = this.querySelector("#giftCardForm");
		if (form) {
			form.removeEventListener("submit", this.handleFormSubmit);
		}
	}

	handleAmountSelection(event) {
		const btn = event.target;

		this.querySelectorAll(".amount-btn").forEach((b) =>
			b.classList.remove("selected"),
		);

		btn.classList.add("selected");

		const amount = btn.dataset.amount;
		const variantId = btn.dataset.id;

		if (variantId) {
			const variantIdInput = this.querySelector("#variantId");
			if (variantIdInput) {
				variantIdInput.value = variantId;
			}

			const stickyATCForm = document.querySelector(".sticky-atc-bar__form");
			if (stickyATCForm) {
				const stickyATCSelect = stickyATCForm.querySelector(
					".sticky-atc-bar__variant-select",
				);
				stickyATCSelect.value = variantId;
				stickyATCSelect.dispatchEvent(new Event("change", { bubbles: true }));

				setTimeout(() => {
					const host = document.querySelector("#givy-custom-amount-anchor");
					const shadow = host?.shadowRoot;
					const input = shadow?.querySelector("input");

					if (input) {
						input.addEventListener("input", this.handleCustomAmountInput);
					}
				}, 500);
			}
		}

		if (amount === "custom") {
			this.config.isCustomAmount = true;
			this.config.selectedAmount = null;
			const customAmountDiv = this.querySelector("#customAmountDiv");
			const customAmountInput = this.querySelector("#customAmount");

			if (customAmountDiv) customAmountDiv.classList.add("show");
			if (customAmountInput) customAmountInput.focus();
		} else {
			this.config.isCustomAmount = false;
			this.config.selectedAmount = parseFloat(amount);
			const customAmountDiv = this.querySelector("#customAmountDiv");
			if (customAmountDiv) customAmountDiv.classList.remove("show");
		}
	}

	handleCustomAmountInput(event) {
		if (this.config.isCustomAmount) {
			this.config.selectedAmount = parseFloat(event.target.value) || null;
		}

		if (event.target?.id === ":r2:") {
			const customAmountInput = this.querySelector("#customAmount");
			if (customAmountInput) {
				customAmountInput.value = event.target.value;
			}
		}
	}

	formatDateForGivy(dateString) {
		if (!dateString) return null;

		const date = new Date(dateString);
		const month = String(date.getMonth() + 1).padStart(2, "0");
		const day = String(date.getDate()).padStart(2, "0");
		const year = date.getFullYear();

		return `${year}-${month}-${day}`;
	}

	async addGiftCardToCart(formData) {
		const amount = this.config.selectedAmount;

		if (
			(this.config.isCustomAmount && !amount) ||
			(this.config.isCustomAmount && amount <= 0)
		) {
			throw new Error("Veuillez sélectionner un montant valide");
		}

		const properties = {
			_givy_gifter_name: formData.gifterName,
			_givy_recipient_name: formData.recipientName,
			_givy_recipient_email: formData.recipientEmail,
			_givy_send_method: formData.sendMethod,
		};

		if (formData.sendMethod === "EMAIL_SEND_METHOD") {
			if (!formData.recipientEmail) {
				throw new Error(
					"L'email du destinataire est requis pour l'envoi par email",
				);
			}
			properties._givy_recipient_email = formData.recipientEmail;
		}

		if (this.config.isCustomAmount && amount) {
			properties._givy_custom_amount = amount.toFixed(2);
		}

		if (formData.sendDate) {
			properties._givy_send_date = this.formatDateForGivy(formData.sendDate);
		}

		if (formData.message) {
			properties._givy_message = formData.message.substring(0, 900);
		}

		const formDataPayload = new FormData();
		formDataPayload.append("id", formData.variantId);
		formDataPayload.append("quantity", "1");

		Object.keys(properties).forEach((key) => {
			formDataPayload.append(`properties[${key}]`, properties[key]);
		});

		if (
			this.cartDrawer &&
			typeof this.cartDrawer.getSectionsToRender === "function"
		) {
			const sections = this.cartDrawer.getSectionsToRender();
			if (sections && sections.length > 0) {
				formDataPayload.append(
					"sections",
					sections.map((section) => section.id).join(","),
				);
			}
		}

		if (
			this.mainCart &&
			typeof this.mainCart.getSectionsToRender === "function"
		) {
			const sections = this.mainCart.getSectionsToRender();
			if (sections && sections.length > 0) {
				formDataPayload.append(
					"sections",
					sections.map((section) => section.section).join(","),
				);
			}
		}

		if (this.mainCart || this.cartDrawer) {
			formDataPayload.append("sections_url", window.location.pathname);
		}

		const { FoxThemeSettings } = window;
		const cartAddUrl =
			FoxThemeSettings?.routes?.cart_add_url ||
			`${window.Shopify.routes.root}cart/add.js`;

		const response = await fetch(cartAddUrl, {
			method: "POST",
			headers: {
				Accept: "application/javascript",
				"X-Requested-With": "XMLHttpRequest",
			},
			body: formDataPayload,
		});

		if (!response.ok) {
			const errorData = await response.json();
			throw new Error(
				errorData.description ||
					errorData.message ||
					"Erreur lors de l'ajout au panier",
			);
		}

		return await response.json();
	}

	async handleFormSubmit(event) {
		event.preventDefault();

		const submitBtn = this.querySelector("#submitBtn");
		const originalText = submitBtn ? submitBtn.textContent : "";

		try {
			if (submitBtn) {
				submitBtn.disabled = true;
				submitBtn.classList.add("btn--loading");
				submitBtn.textContent = "Ajout en cours...";
			}

			const formData = {
				gifterName: this.querySelector("#gifterName")?.value.trim() || "",
				recipientName: this.querySelector("#recipientName")?.value.trim() || "",
				recipientEmail:
					this.querySelector("#recipientEmail")?.value.trim() || "",
				sendMethod: this.querySelector("#sendMethod")?.value || "",
				sendDate: this.querySelector("#sendDate")?.value || "",
				message: this.querySelector("#message")?.value.trim() || "",
				variantId: this.querySelector("#variantId")?.value || "",
			};

			if (
				!formData.gifterName ||
				!formData.recipientName ||
				!formData.sendMethod ||
				!formData.variantId
			) {
				throw new Error("Veuillez remplir tous les champs requis");
			}

			if (this.config.isCustomAmount && !this.config.selectedAmount) {
				throw new Error("Veuillez sélectionner un montant");
			}

			const result = await this.addGiftCardToCart(formData);
			if (result.status) {
				throw new Error(result.description || result.message);
			}

			if (window.FoxThemeEvents) {
				window.FoxThemeEvents.emit("ON_ITEM_ADDED", result);
			}

			setTimeout(() => {
				if (this.cartDrawer && typeof this.cartDrawer.open === "function") {
					this.cartDrawer.open();
				}
			}, 200);
		} catch (error) {
			console.error("Erreur:", error);

			if (window.FoxTheme?.Notification) {
				window.FoxTheme.Notification.show({
					target: document.body,
					method: "appendChild",
					type: "warning",
					message: error.message,
					last: 3000,
					sticky: true,
				});
			} else {
				alert(`Erreur: ${error.message}`);
			}
		} finally {
			if (submitBtn) {
				submitBtn.disabled = false;
				submitBtn.classList.remove("btn--loading");
				submitBtn.textContent = originalText;
			}
		}
	}
}

if (!customElements.get("gift-card-form")) {
	customElements.define("gift-card-form", GiftCardForm);
}
